import React, { useState } from 'react'
import Menu from '@mui/material/Menu'

//images
import menuIcon from '../../../../assets/img/icons/table-menu.png'
import editIcon from '../../../../assets/img/icons/edit.svg'
import deleteIcon from '../../../../assets/img/icons/delete.svg'
import mailIcon from '@/assets/img/reservations/icons/send.svg'
import previewIcon from '@/assets/img/reservations/icons/preview.svg'
import duplicateImage from '@/assets/img/reservations/icons/duplicate.svg'
import deactivateIcon from '@/assets/img/contractors/icons/deactivate.svg'
import { trans } from '../../../../_providers/Translation'

function Index(props) {
    // Provide default stub functions for new actions if not passed
    const noop = () => { }
    const handlePreview = props.handlePreview || noop
    const handleDuplicate = props.handleDuplicate || noop
    const handleSend = props.handleSend || noop

    const [table, setTable] = useState({
        options: null
    })

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        })
    }

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        })
    }

    const handleEdit = id => {
        handleCloseMenu()
        props.handleEdit(id)
    }

    const handleDelete = id => {
        handleCloseMenu()
        props.handleDelete(id)
    }

    const handleStopRepeat = id => {
        handleCloseMenu()
        props.handleStopRepeat(id)
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >

                {Number(props.data.repeat) === 1 || (props.data.parent && Number(props.data.parent.repeat) === 1)
                    ?
                    <div className="menu-option" onClick={() => handleStopRepeat(props.id)}>
                        <img src={deactivateIcon} alt="edit" />
                        {trans('buttons.noRepeat')}
                    </div>
                    :
                    ''
                }

                <div className="menu-option" onClick={() => { handlePreview(props.id); handleCloseMenu() }}>
                    <img src={previewIcon} alt="preview" />
                    {trans('buttons.preview') || 'Preview'}
                </div>
                <div className="menu-option" onClick={() => handleEdit(props.id)}>
                    <img src={editIcon} alt="edit" />
                    {trans('buttons.edit')}
                </div>
                <div className="menu-option" onClick={() => { handleDuplicate(props.id); handleCloseMenu() }}>
                    <img src={duplicateImage} alt="duplicate" />
                    {trans('buttons.duplicate')}
                </div>
                <hr
                    style={{
                        margin: "5px 0"
                    }}
                />
                <div className="menu-option with-menu" onClick={() => { handleSend(props.id); handleCloseMenu() }}>
                    <img src={mailIcon} alt="send" />
                    {trans('buttons.send')}
                </div>
                <hr
                    style={{
                        margin: "5px 0"
                    }}
                />
                <div
                    className="menu-option"
                    onClick={() => handleDelete(props.id)}
                    style={{
                        color: "#EC5252"
                    }}
                >
                    <img src={deleteIcon} alt="delete" />
                    {trans('buttons.delete')}
                </div>
            </Menu>
        </>
    )
}

export default Index
